<script setup lang="ts">
import { Holidays } from "~/composables/useHolidayVibes";

const { updateOngoingHoliday, ongoingHoliday } = useHolidayVibes();

onBeforeMount(() => {
  updateOngoingHoliday();
});

const uibColor = computed(() => {
  if (ongoingHoliday.value === Holidays.ValentinesDay) {
    return '#e24767';
  }

  return 'var(--palette-blue-50)';
});
</script>

<template>
  <div
    class="loader relative flex justify-center items-center w-full"
    :style="{'--uib-color': uibColor}"
  >
    <div class="relative">
      <svg
        class="container z-[2]"
        x="0px"
        y="0px"
        viewBox="0 0 50 31.25"
        height="31.25"
        width="50"
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          class="track"
          stroke-width="4"
          fill="none"
          pathlength="100"
          d="M0.625 21.5 h10.25 l3.75 -5.875 l7.375 15 l9.75 -30 l7.375 20.875 v0 h10.25"
        />
        <path
          class="fill"
          stroke-width="4"
          fill="none"
          pathlength="100"
          d="M0.625 21.5 h10.25 l3.75 -5.875 l7.375 15 l9.75 -30 l7.375 20.875 v0 h10.25"
        />
      </svg>

      <!-- valentine's day -->
      <svg
        v-if="ongoingHoliday === Holidays.ValentinesDay"
        viewBox="0 0 667 574"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="heart absolute top-1/2 left-1/2 w-full h-full z-[1]"
      >
        <path d="M0 195.073C0 357.17 133.981 443.55 232.058 520.866C266.667 548.15 300 573.836 333.333 573.836C366.667 573.836 400 548.15 434.61 520.866C532.687 443.55 666.667 357.17 666.667 195.073C666.667 32.975 483.327 -81.9816 333.333 73.8573C183.339 -81.9816 0 32.975 0 195.073Z" />
      </svg>
    </div>
  </div>
</template>

<style>
.loader {
  --uib-size: 45px;
  --uib-speed: 1.75s;
  --uib-bg-opacity: .1;

  --uib-color: var(--palette-blue-50);
}

.container {
  height: 31.25px;
  width: 50px;
  transform-origin: center;
  overflow: visible;
}

.fill {
  stroke: var(--uib-color);
  stroke-dasharray: 100;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  stroke-linejoin: round;
  animation:
      travel var(--uib-speed) ease-in-out infinite,
      fade var(--uib-speed) ease-out infinite;
  will-change: stroke-dasharray, stroke-dashoffset;
  transition: stroke 0.5s ease;
}

.track {
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke: var(--uib-color);
  opacity: var(--uib-bg-opacity);
}

@keyframes travel {
  0% {
    stroke-dashoffset: 100;
  }

  75% {
    stroke-dashoffset: 0;
  }
}

@keyframes fade {
  0% {
    opacity: 0;
  }

  20%,
  55% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

/*
 * valentine's day
 */
.heart {
  transform: translate(-50%, -50%) scale(2);
  animation: bouncy var(--uib-speed) ease-in-out infinite;

  path {
    fill: var(--uib-color);
    animation: pulse var(--uib-speed) ease-in-out infinite;
  }
}

@keyframes bouncy {
  0%, 100% {
    transform: translate(-50%, -50%) scale(2);
  }
  50% {
    transform: translate(-50%, -50%) scale(2.2);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.05;
  }
  60% {
    opacity: 0.2;
  }
}

</style>